import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 4),
    backgroundColor: theme.colorPalette.green_100,
    color: theme.colors.white,
    justifyContent: 'center',
    ...reskinStyles(theme, { border: 0 })
  }
});

export default makeStyles(styles);
